module.exports = __webpack_public_path__ + "app/principal/principal-layout-1KfzPh_t.html";